import React, { useState, useEffect } from 'react';
import styles from './overlay.module.css';
import { Autocomplete, TextField, Chip, Snackbar, Box } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import useAxiosPrivate from "../../utils/hooks/useAxiosPrivate";
import Alert from '@material-ui/lab/Alert';
import DeleteUserModal from './deleteUserModal';
import { useSelector } from "react-redux";
import { withStyles } from '@material-ui/core/styles';

const CssTextField = withStyles({
    root: {
        "& label.Mui-focused": {
            color: "var(--primary-text-theme-color)",
        },
        "& .MuiInput-underline:after": {
            borderBottomColor: "var(--primary-text-theme-color)",
        },
        "& .MuiOutlinedInput-root": {
            boxSizing: "border-box",
            color: "var(--primary-text-color)",
            backgroundColor: "var(--primary-popup-background-color)",
            minHeight: "48px",
            height: "auto",
            flexWrap: "wrap",
            alignItems: "center",
            padding: "4px 8px",
            overflowX: "visible",
            overflowY: "visible",
            borderRadius: "4px",
            border: "1px solid var(--primary-popup-stroke-color)",
            "& .MuiOutlinedInput-notchedOutline, &.Mui-focused .MuiOutlinedInput-notchedOutline, &:hover .MuiOutlinedInput-notchedOutline": {
                border: "none !important",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
            },
            "&:hover": {
                borderColor: "var(--primary-text-theme-color)",
            },
            "&.Mui-focused": {
                borderColor: "var(--primary-text-theme-color)",
                boxShadow: "none",
                outline: "none",
            },
            "& legend": {
                display: "none",
            },
        },
        "& .MuiChip-root": {
            outline: "none",
        },
        "& .MuiChip-root.Mui-focusVisible": {
            outline: "none",
            boxShadow: "none",
        },
        "& .MuiInputBase-input": {
            color: "var(--primary-text-color)",
            outline: "none",
        },
        "& .MuiAutocomplete-input": {
            minWidth: "120px",
            flex: "1 0 auto",
            outline: "none",
            padding: "4px 4px",
        },
        "& .MuiAutocomplete-tag": {
            margin: "2px",
        },
        "& .MuiInputBase-input::placeholder": {
            color: "var(--primary-text-color-80)",
            opacity: 1,
        },
        "& .MuiFormLabel-root": {
            color: "var(--primary-text-color-80)",
        },
        "& .MuiFormLabel-root.Mui-error": {
            color: "gray !important",
        },
        "& .MuiFormHelperText-root.Mui-error": {
            color: "red !important",
        },
        "& .MuiInputBase-input.Mui-disabled": {
            WebkitTextFillColor: "var(--primary-text-color)",
            color: "var(--primary-text-color)",
        },
        "& .MuiSvgIcon-root": {
            color: "var(--primary-text-color-80)",
        },
    },
})(TextField);

export default function Users() {
    const axios = useAxiosPrivate()
    const role = useSelector((state) => state.auth.role);
    const [emails, setEmails] = useState([]);
    const [admins, setAdmins] = useState([]);
    const [opened, setOpened] = useState(false);
    const [id, setID] = useState('');
    const [emailsValidation, setEmailsValidation] = useState([]);

    const [alert, setAlert] = useState({
        showAlert: false,
        severity: 'success',
        message: '',
    });

    const addEmails = (arr) => {
        let testArray = [];
        setEmails(arr);
        arr.map((item) => {
            const result = checkEmail(item);
            if (result) {
                return testArray.push(true);
            } else {
                return testArray.push(false);
            }
        })
        setEmailsValidation(testArray);
    };

    const sendInvite = () => {
        if (emails.length === 0) {
            setAlert({
                showAlert: true,
                severity: 'error',
                message: 'Please enter an email address and press ENTER to invite.',
            });
        }
        emails.map(async (item) => {
            try {
                await axios.post('/user/invite', {
                    email: item,
                });
                setAlert({
                    showAlert: true,
                    severity: 'success',
                    message: 'Sent invite Successfully!',
                });
                window.location.href = '/users';
            } catch (error) {
                if (error.response.status === 401) {
                    setAlert({
                        showAlert: true,
                        severity: 'error',
                        message: 'Invalid Authentication!',
                    });
                } else if (error.response.status === 404) {
                    setAlert({
                        showAlert: true,
                        severity: 'error',
                        message: 'User not found.!',
                    });
                } else if (error.response.status === 400) {
                    setAlert({
                        showAlert: true,
                        severity: 'error',
                        message: "User with email address already exist.",
                    });
                } else {
                    setAlert({
                        showAlert: true,
                        severity: 'error',
                        message: 'Server error!',
                    });
                }
            }
        });
    };

    const checkEmail = (address) => {
        let regex = new RegExp(
            // eslint-disable-next-line
            "([!#-'*+/-9=?A-Z^-~-]+(.[!#-'*+/-9=?A-Z^-~-]+)*|\"([]!#-[^-~ \t]|(\\[\t -~]))+\")@([!#-'*+/-9=?A-Z^-~-]+(.[!#-'*+/-9=?A-Z^-~-]+)*|[[\t -Z^-~]*])"
        );
        return regex.test(address);
    };

    const loadData = async () => {
        const { data } = await axios.get('/team/admins/pending');
        setAdmins(data.data);
    }

    const handleDelete = (id) => {
        setID(id);
        setOpened(true)
    }

    useEffect(() => {
        loadData();
        // eslint-disable-next-line
    }, [])

    const handleClose = () => {
        setAlert({
            showAlert: false,
            severity: "success",
            message: "",
        })
    };

    return (
        <div style={{ backgroundColor: 'var(--primary-background-color)', minHeight: 'calc(100vh - 64px)', marginTop: "-2rem" }}>
            <p className={styles.headerText}>Invite Your Dashboard Users</p>
            <div className={styles.inputRow}>
                <div className={styles.inputContainer}>
                    <Autocomplete
                        multiple
                        freeSolo
                        fullWidth
                        open={false}
                        className={styles.autocomplete}
                        onChange={(event, newValue) => {
                            addEmails(newValue);
                        }}
                        options={[]}
                        getOptionLabel={(option) => option}
                        renderTags={(value, getTagProps) =>
                            value.map((option, index) => (
                                <React.Fragment key={`${option}-${index}`}>
                                    {checkEmail(option) ? (
                                        <div className={styles.emailChip}>
                                            <Chip
                                                style={{
                                                    fontFamily: 'normal normal normal 12px Poppins',
                                                    letterSpacing: '0px',
                                                    background: '#ECF9F7',
                                                    color: '#000000',
                                                    opacity: 1,
                                                    fontWeight: 400,
                                                    fontSize: '1rem',
                                                    lineHeight: '1.37rem',
                                                    height: "2rem",
                                                    borderRadius: '6px',
                                                }}
                                                size='small'
                                                label={option}
                                                deleteIcon={
                                                    <CloseIcon
                                                        style={{
                                                            fontSize: '0.65rem',
                                                            color: '#FFFFFF',
                                                            background: '#000000',
                                                            borderRadius: '50%',
                                                            padding: '1px',
                                                        }}
                                                    />
                                                }
                                                {...getTagProps({ index })}
                                            />
                                        </div>
                                    ) : (
                                        <div className={styles.errorChip}>
                                            <Chip
                                                style={{
                                                    fontFamily: 'normal normal normal 12px Poppins',
                                                    letterSpacing: '0px',
                                                    background: 'transparent',
                                                    color: '#FFFFFF',
                                                    opacity: 1,
                                                    fontWeight: 400,
                                                    fontSize: '1rem',
                                                    lineHeight: '1.37rem',
                                                    height: "2rem",
                                                    borderRadius: '6px',
                                                }}
                                                size='small'
                                                label={option}
                                                deleteIcon={
                                                    <CloseIcon
                                                        style={{
                                                            fontSize: '0.65rem',
                                                            color: '#000000',
                                                            background: '#FFFFFF',
                                                            borderRadius: '50%',
                                                            padding: '1px',
                                                        }}
                                                    />
                                                }
                                                {...getTagProps({ index })}
                                            />
                                        </div>
                                    )}
                                </React.Fragment>
                            ))
                        }
                        renderInput={(params) => (
                            <CssTextField
                                placeholder={
                                    emails.length === 0
                                        ? 'Insert email to add dashboard users, divide by enter'
                                        : ''
                                }
                                {...params}
                            />
                        )}
                    />
                    <button
                        type='button'
                        className={
                            emails.length > 0 && !emailsValidation.includes(false)
                                ? styles.searchButton
                                : styles.disabled
                        }
                        disabled={
                            !(emails.length > 0 && !emailsValidation.includes(false))
                        }
                        onClick={
                            emails.length > 0 && !emailsValidation.includes(false)
                                ? sendInvite
                                : undefined
                        }
                    >
                        Send Invite
                    </button>
                </div>
            </div>
            <div style={{ display: 'flex', justifyContent: 'center', padding: '0 2rem' }}>
                <div style={{
                    boxSizing: 'border-box',
                    width: '57%',
                    marginTop: '1rem',
                    marginBottom: '4rem',
                    padding: '1.8rem',
                    backgroundColor: 'var(--primary-popup-background-color)',
                    border: '3px solid var(--primary-popup-stroke-color)'
                }}>
                    <Box sx={{ height: 500, overflowY: "auto", paddingRight: "1rem", marginRight: "-1.5rem" }}>
                        <p className={styles.descriptionTittle}>People who are invited will receive a link to create an
                            account and be able to use the dashboard. </p>
                        {admins.map((admin) => (
                            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                <p className={styles.emailPara}>{admin.email}</p>
                                {role === "SUPER_ADMIN" &&
                                    <p className={styles.emailDelete} onClick={() => { handleDelete(admin?.id) }}>Delete</p>
                                }
                            </div>
                        ))}
                    </Box>
                </div>
            </div>
            <Snackbar
                open={alert.showAlert}
                autoHideDuration={4000}
                onClose={handleClose}
                anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
            >
                <Alert
                    severity={alert.severity}
                    onClose={handleClose}
                >
                    {alert.message}
                </Alert>
            </Snackbar>
            <DeleteUserModal setOpen={setOpened} open={opened} id={id} setAlert={setAlert} loadData={loadData} />
        </div>
    );
}
